import { useEffect, useState } from "react";
import { getInventoryTransactionTypes } from "../../api/inventoryService";

export const useInventoryTransactionTypes = (trigger, emptyCallback) => {
  const [inventoryTransactionTypes, setInventoryTransactionTypes] = useState({});
  const [loading, setLoading] = useState(true);

    useEffect(() => {
        getInventoryTransactionTypes()
            .then((types) => {
                setInventoryTransactionTypes(types.data);
                if (emptyCallback && types.data.length === 0) emptyCallback(true);
            })
            .catch((error) => {
                console.error("Failed to fetch inventory transaction types:", error);
            })
            .finally(() => {
                setLoading(false);
            });
    }, [trigger]);

  return { inventoryTransactionTypes, loading, setInventoryTransactionTypes };
};
